import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import RangeDialog from '@/components/RangeDialog.vue'
import PointDialog from '@/components/PointDialog.vue'
import FalconIoDialog from '@/components/FalconIoDialog.vue'
import ChangelogDialog from '@/components/ChangelogDialog.vue'
import ChangePasswordDialog from '@/components/ChangePasswordDialog.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/r:rangeId',
            name: 'range',
            component: RangeDialog,
            props: true,
        },
        {
            path: '/p:pointId/:type?',
            name: 'point',
            component: PointDialog,
            props: true,
        },
        {
            path: '/falcon.io',
            name: 'falconio',
            component: FalconIoDialog,
            props: true,
        },
        {
            path: '/changelog',
            name: 'changelog',
            component: ChangelogDialog,
            props: true,
        },
        {
            path: '/change-password',
            name: 'change-password',
            component: ChangePasswordDialog,
            props: true,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/router/index.ts